import { jsx as m } from "react/jsx-runtime";
import h from "../items/link/link-thumbnail.mjs";
import d from "../items/optin/optin-thumbnail.mjs";
import l from "../items/header/preview.mjs";
import u from "../items/product/thumbnail.mjs";
import { StoreItemEnum as a } from "../enums/store-item-enum.mjs";
const t = (r, e) => {
  switch (r.type) {
    case a.link:
      return /* @__PURE__ */ m(h, { ...r, headingLevel: e == null ? void 0 : e.headingLevel });
    case a.optin:
      return /* @__PURE__ */ m(d, { ...r, headingLevel: e == null ? void 0 : e.headingLevel });
    case a.header:
      return /* @__PURE__ */ m(l, { ...r });
    case a.product:
      return /* @__PURE__ */ m(u, { ...r, headingLevel: e == null ? void 0 : e.headingLevel });
  }
};
export {
  t as getCommonItem
};
